import TypeaheadUtils from "./typeahead_utils";
import CustomDataList from "./bindCustomDataList";
const Repeatable_Utils = {
    dummyKey: "dummyKey",
    oldJSON: {},
    oldRepeatableRowData: {},
    rowHtml: null,
    repeatableData: {},
    firstRowElement: {},
    oldRepRow: {},
    emptyRepeatableRow: false,

    renderRepeatableRows(dataJson) {
        var self = this;
        window.dataAsJson = [];
        this.oldRepRow = {};
        if (typeof dataJson == "string") {
            dataJson = JSON.parse(dataJson);
        }
        $("div[name='repeatable-row-data']").remove();
        $("div[data-repeatablerow='true']").each(function (index, element) {
            // Check parent rep row
            if ($(element).parent().closest($("div[data-repeatablerow='true']")).length > 0) {
                return;
            }
            let jsonData = {};
            self.createDataJSON($(this),jsonData);

            $(this).find(`[data-repeatablerow="true"]`).each(function () {
                var childDataSrcName = $(this).attr("data-datasource");
                var childRepData = {};
                self.createDataJSON($(this), childRepData);
                    if (!jsonData.hasOwnProperty(childDataSrcName)) {
                        jsonData[childDataSrcName] = []
                    }
                    jsonData[childDataSrcName].push(childRepData);
                    let childDataJsonAttr = $(this).attr("data-json");
                    if (typeof childDataJsonAttr === typeof undefined) {
                        $(this).attr("data-json", JSON.stringify(childRepData));
                    }
            });

            var dataJsonAttr = $(this).attr("data-json");
            if (typeof dataJsonAttr === typeof undefined) {
                $(this).attr("data-json", JSON.stringify(jsonData));
            }

            self.repeatableData[$(this).attr('data-datasource')] = $(this).data('obj');
            self.firstRowElement[$(this).attr('data-datasource')] = $(this);
            self.splitDataSourceAndPopulateRow(this, dataJson)
        });
        let keys = Object.keys(this.oldRepRow);
        // Update oldRepRow Data
        keys.forEach((item, index) => {
            var input = $("<input>").attr("type", "hidden").attr("name",
                'oldRepeatableRow' + (index + 1)).attr("value", JSON.stringify(this.oldRepRow[item]));
            $('#render-canvas').append($(input));
        })
    },
    updateChildrenToReadonly(repeatableObj) {
        var self = this;
        var isReadOnly = $(repeatableObj).attr("isreadonly");
        var parentName = $(repeatableObj).attr("newname");
        if (isReadOnly != null && isReadOnly == "true") {
            setTimeout(function () {
                $(repeatableObj).find("[data-datafield]").each(
                    function (ind, obj) {
                        let repRowName = self.getParentRepRowName($(this));
                        if (parentName != repRowName) {
                            return;
                        }
                        $(obj)[0].disabled = true;
                        if ($(obj).find('.mc-form__control').length > 0) {
                            $(obj).find('.mc-form__control').prop("disabled", true).attr("disabled", "disabled");
                        }
                        if ($(obj).find('.form-checkbox').length > 0) {
                            $(obj).find('.form-checkbox').prop("disabled", true).attr("disabled", "disabled");
                        }
                        if ($(obj).find('.form-radio').length > 0) {
                            $(obj).find('.form-radio').prop("disabled", true).attr("disabled", "disabled");
                        }
                    });
            }, 0);
        }
    },
    remove(obj, key) {
        let objAssign = {};
        objAssign[key] = obj[key];
        return $.extend({}, {}, objAssign);
    },
    createObject(object, path, value) {
        var keys = path.split('.'), last = keys.pop();
        keys.reduce(function (o, k) {
            return o[k] = o[k] || {};
        }, object)[last] = value;
    },
    updateValidation() {
        $("[data-repeatablerow='true']").first().find("mosaic-number-input").each((index, e) => {
            $(e).removeAttr("invalid");
        });
        setTimeout(() => {
            window.applyDecimalValidation($("#render-canvas"), false);
        }, 200);
    },
    bindAddDeleteEventsForRepeatableRow() {
        var self = this;
        $('.add-row').unbind('click');
        $('.delete-row').unbind('click');
        $(".add-row").click(function () {
            var parentRowObj = $(this).closest("div[data-repeatablerow='true']");
            var jsonObjKey = parentRowObj.attr("newname");
            var dataSrc = parentRowObj.attr("data-datasource");
            var arrayData = $(`div[data-repeatablerow='true'][data-datasource='${dataSrc}']`).first().attr("data-json");
            var currentJsonData = window.dataAsJson[dataSrc];

            // Check if parentRowObj is child repeatable row.
            var rootRepRow = $(parentRowObj).parent().closest("div[data-repeatablerow='true']");
            let isChildRepRow = rootRepRow.length > 0;
            if (dataSrc.indexOf(self.dummyKey) != -1) {
                jsonObjKey = self.dummyKey + "." + jsonObjKey;
            }
            if (isChildRepRow) {
                let rootDataSrc = rootRepRow.attr("data-datasource");
                currentJsonData = window.dataAsJson[rootDataSrc];
                if (rootDataSrc.indexOf(self.dummyKey) != -1) {
                    jsonObjKey = self.dummyKey + "." + parentRowObj.attr("childnewname");
                } else {
                    jsonObjKey = parentRowObj.attr("childnewname");
                }
                // jsonObjKey = self.dummyKey + "." + parentRowObj.attr("childnewname");
                dataSrc = rootDataSrc;
            }

            self.updateExistingJson(currentJsonData, dataSrc);
            // Split with . , check if - is there then append []
            var newJsonKey = self.splitJsonKey(jsonObjKey.split("."));
            self.addItemToJson(currentJsonData, newJsonKey, arrayData);
            $("div[name='repeatable-row-data']").remove();
            $("div[data-datasource='" + dataSrc + "']").not(':first').remove();
            self.splitDataSourceAndPopulateRow($("div[data-datasource='" + dataSrc + "']"), currentJsonData);
            self.updateValidation();
        });

        $(".delete-row").click(function () {
            var parentRowObj = $(this).closest("div[data-repeatablerow='true']");
            var jsonObjKey = parentRowObj.attr("newname");
            var dataSrc = parentRowObj.attr("data-datasource");
            var childDataSrc = dataSrc;
            if (dataSrc.indexOf(self.dummyKey) != -1) {
                jsonObjKey = self.dummyKey + "." + jsonObjKey;
            }
            var newJsonKey = self.splitJsonKey(jsonObjKey.split("."));
            // Check if parentRowObj is child repeatable row.
            var rootRepRow = $(parentRowObj).parent().closest("div[data-repeatablerow='true']");
            let isChildRepRow = rootRepRow.length > 0;
            if (isChildRepRow) {
                let rootDataSrc = rootRepRow.attr("data-datasource");
                if (rootDataSrc.indexOf(self.dummyKey) != -1) {
                    newJsonKey = self.dummyKey + "." + parentRowObj.attr("childnewname");
                } else {
                    newJsonKey = parentRowObj.attr("childnewname");
                }
                newJsonKey = self.splitJsonKey(newJsonKey.split("."));
                dataSrc = rootDataSrc;
                // check if there are more than one child to delete. You should not be able to
                // delete last child(0th index child in array).
                let count = $(rootRepRow).find(`div[data-datasource='${childDataSrc}']`).length;
                if (count <= 1) {
                    return;
                }
            }

            self.updateExistingJson(window.dataAsJson[dataSrc], dataSrc);
            if ($("div[data-datasource='" + dataSrc + "']").length > 1) {
                self.path(window.dataAsJson[dataSrc], newJsonKey);
                $("div[name='repeatable-row-data']").remove();
                $("div[data-datasource='" + dataSrc + "']").not(':first').remove();
                self.splitDataSourceAndPopulateRow($("div[data-datasource='" + dataSrc + "']"), window.dataAsJson[dataSrc]);
            } else if (isChildRepRow) {
                self.path(window.dataAsJson[dataSrc], newJsonKey);
                $("div[data-datasource='" + dataSrc + "']").not(':first').remove();
                self.splitDataSourceAndPopulateRow($("div[data-datasource='" + dataSrc + "']"), window.dataAsJson[dataSrc]);
            }
            self.updateValidation();
        });
    },
    splitJsonKey(jsonKeyRef) {
        var newJsonKey = "";
        for (var ref = 0; ref < jsonKeyRef.length; ref++) {
            if (ref == 0) {
                newJsonKey = jsonKeyRef[0];
            } else if (jsonKeyRef[ref].indexOf("-") != -1) {
                if (jsonKeyRef[ref].indexOf("[") != -1) {
                    newJsonKey = newJsonKey + "['" + jsonKeyRef[ref].split("[")[0]
                        + "']" + "[" + jsonKeyRef[ref].split("[")[1];
                } else {
                    newJsonKey = newJsonKey + "['" + jsonKeyRef[ref] + "']";
                }
            } else {
                newJsonKey = newJsonKey + "." + jsonKeyRef[ref];
            }
        }
        return newJsonKey;
    },

    // Function to update particular entry from json object
    updatePath(obj, path, dataFieldName, dataFieldVal) {
        try {
            if (dataFieldName.indexOf("[") == 0) {
                eval("obj." + path + dataFieldName + "=dataFieldVal");
            } else if (/^\d/.test(dataFieldName)) {
                eval("obj." + path + "['" + dataFieldName + "']=dataFieldVal");
            } else {
                eval("obj." + path + "." + dataFieldName + "=dataFieldVal");
            }
        } catch (e) {
            return undefined;
        }
    },
    // Function to delete particular entry from json object
    path(obj, path) {
        try {
            eval("delete obj." + path);
        } catch (e) {
            return undefined;
        }
    },
    // Function to add particular entry in json object
    addPath(obj, path, index, arrayData) {
        try {
            eval("obj." + path + ".splice(" + index + ",0," + arrayData + ")");
        } catch (e) {
            return undefined;
        }
    },
    updateValueInJSON(rowEle, jsonData, parentName, orignalName) {
        var self = this;
        $(rowEle).find("[data-datafield]").each(function () {
            let repRowName = self.getParentRepRowName($(this));
            if (orignalName != repRowName) {
                return;
            }
            var dataFieldName = $(this).attr("data-datafield");
            let updatedFieldName = '';
            let newDataFieldName = dataFieldName.split(".")
            if (newDataFieldName.length > 1) {
                for (let i = 0; i < newDataFieldName.length; i++) {
                    updatedFieldName += '[\'' + newDataFieldName[i] + '\']';
                }
            } else {
                updatedFieldName = dataFieldName;
            }
            var parentNameTemp = parentName;
            if (parentNameTemp == null || parentNameTemp == "") {
                parentNameTemp = dataSrc + "[0]";
            }

            var dataFieldVal = self.getValueOfControl($(this));
            self.updatePath(jsonData, parentNameTemp, updatedFieldName, dataFieldVal);
        });
    },
    updateExistingJson(jsonData, dataSrc) {
        var self = this;
        $('[data-repeatablerow="true"][data-datasource="' + dataSrc + '"]').each(
            function (index) {
                var orignalName = $(this).attr("newname");
                var parentName = orignalName;
                if (dataSrc.indexOf(self.dummyKey) != -1) {
                    parentName = self.dummyKey + "." + parentName;
                }
                parentName = self.splitJsonKey(parentName.split("."));
                self.updateValueInJSON($(this), jsonData, parentName, orignalName)
                $(this).find(`[data-repeatablerow="true"]`).each(function (index1, element) {
                    let childDataSrc = $(element).attr("newname");
                    let newParentName = parentName + "." + childDataSrc;
                    // parentName += "." + childDataSrc; 
                    newParentName = self.splitJsonKey(newParentName.split("."));
                    self.updateValueInJSON($(this), jsonData, newParentName, childDataSrc)
                });
            });
    },
    addItemToJson(o, s, arrayData) {
        var originalKey = s;
        s = s.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
        s = s.replace(/^\./, ''); // strip a leading dot
        var a = s.split('.');
        originalKey = originalKey.substr(0, originalKey.lastIndexOf("["));
        this.addPath(o, originalKey, parseInt(a[a.length - 1]) + 1, arrayData);
        return o;
    },
    byString(o, s, obj, path) {
        s = s.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
        s = s.replace(/^\./, ''); // strip a leading dot
        var a = s.split('.');
        for (var i = 0, n = a.length; i < n; ++i) {
            var k = a[i];
            if (k in o) {
                o = o[k];
            } else {
                return;
            }
        }

        return o;
    },
    initialUpdatingOfDataJson(originalDataSource, dataSource, dataAsJson, el) {
        var ele = $('<div name="repeatable-row-data" class="d-none"></div>');
        $('body').append(ele);
        let bKeyNotFound = this.checkIfDataSourceFoundInJson(originalDataSource, dataSource, dataAsJson, ele)
        let jsonObj = {};
        if (originalDataSource != dataSource) {
            window.dataAsJson[originalDataSource] = dataAsJson;
            jsonObj = window.dataAsJson[originalDataSource]
        } else {
            window.dataAsJson = dataAsJson;
            jsonObj = window.dataAsJson;
        }

        if (bKeyNotFound) {
            this.addNewEntryToJson(jsonObj, originalDataSource);
        }
        this.updateNewName(originalDataSource);
    },
    checkIfDataSourceFoundInJson(originalDataSource, dataSource, dataAsJson, el) {
        let obj = [];
        let newObj = [];
        if (originalDataSource != dataSource) {
            obj = this.recursiveKeySearch(dataSource, dataAsJson, el);
        } else {
            obj = this.recursiveKeySearch(dataSource,
                dataAsJson[originalDataSource], el);
        }

        for (let i = 0; i < obj.length; i++) {
            if (obj[i].constructor === Array) {
                for (let j = 0; j < obj[i].length; j++) {
                    newObj.push(obj[i][j]);
                }
            }
        }

        if (newObj.length == 0) {
            newObj = obj;
        }

        return obj.length == 0 && newObj.length == 0;
    },
    updateNewName(originalDataSource) {
        var self = this;
        $(`[data-repeatablerow="true"][data-datasource="${originalDataSource}"]`).each(function (index) {
            $(this).attr("newname", self.getNameForRepeatableRowElements(originalDataSource, index));
            $(this).find(`[data-repeatablerow="true"]`).each(function (index1, element) {
                $(element).attr("child-repeatablerow", "true");
                let childDataSrc = $(element).attr("data-datasource");
                $(this).attr("newname", self.getNameForRepeatableRowElements(childDataSrc, index1));
            });
        });
    },
    getParentRepRowName(ele) {
        let repRow = $(ele).closest('[data-repeatablerow="true"]');
        return $(repRow).attr("newname");
    },
    createDataJSON(rowEle, jsonData) {
        let self = this;
        let rowEleDataSource = $(rowEle).attr("data-datasource");
        $(rowEle).find("[data-datafield]").each(function () {
            let dataFieldName = $(this).attr("data-datafield");
            let parentDataSource = $(this).closest('[data-repeatablerow="true"]').attr("data-datasource");
            if (parentDataSource != rowEleDataSource) {
                return;
            }
            var defaultValueOfControl = self.getValue($(this));
            var strArray = dataFieldName.split('.');
            if (strArray.length == 1) {
                if (jsonData[dataFieldName] != undefined && jsonData[dataFieldName] != "") {
                    if (defaultValueOfControl != "") {
                        jsonData[dataFieldName] = jsonData[dataFieldName] + "," + defaultValueOfControl;
                    }
                }
                else {
                    jsonData[dataFieldName] = defaultValueOfControl;
                }
            } else {
                var current = jsonData;
                for (var j = 0; j < strArray.length; j++) {
                    if (j == strArray.length - 1) {
                        if (defaultValueOfControl != null) {
                            current[strArray[j]] = defaultValueOfControl;
                        } else {
                            current[strArray[j]] = "";
                        }
                    } else if (!current.hasOwnProperty(strArray[j])) {
                        current[strArray[j]] = {};
                    }
                    current = current[strArray[j]];
                }
            }
        });
    },
    updateChildDataField(rowEle, parentName, index, jsonData, newObj, isArrayInsideArray, isChildRepRow, childRepRowName) {
        var self = this;
        $(rowEle).find("[data-datafield]").each(function (i, element) {
            var dataFieldName = $(this).attr("data-datafield");
            let repRowName = self.getParentRepRowName($(this));
            if (parentName != repRowName) {
                return;
            }
            if (parentName != "") {
                let parentNameMerged = parentName;
                if (isChildRepRow) {
                    parentNameMerged = childRepRowName
                }

                $(rowEle).find(`[data-datafield="${dataFieldName}"]`).attr("name", parentNameMerged + "." + dataFieldName)

                // Check if datafield is inside child repeatable row
                // $(this).attr("name", parentNameMerged + "." + dataFieldName);
                // Update internal input, select element etc
                $(this).not('[readonly]').attr("name", parentNameMerged + "." + dataFieldName);
            }

            $(rowEle).find('[data-cr-field]').each(function () {
                if ($(this).attr('data-cr-field') == dataFieldName && parentName != "") {
                    $(this).attr('data-cr-field', parentName + "." + dataFieldName);
                }
            });

            var strArray = dataFieldName.split('.');

            if (isArrayInsideArray) {
                if (strArray.length == 1) {
                    var fieldVal = newObj[index].hasOwnProperty(dataFieldName) ? newObj[index][dataFieldName] : "";
                    if (fieldVal != "" && newObj[index].hasOwnProperty(dataFieldName + "_submitDateFormat")) {
                        if (newObj[index][dataFieldName + "_submitDateFormat"] != null && newObj[index][dataFieldName + "_submitDateFormat"] != "") {
                            var sumbitFormat = newObj[index][dataFieldName + "_submitDateFormat"];
                            newObj[index][dataFieldName + "_submitDateFormat"] = "";
                            fieldVal = self.getDisplayDate($(this), sumbitFormat, fieldVal);
                        }
                    }
                    if (self.isMultiSelect($(this))) {
                        self.setMultiSelectVal($(this), fieldVal);
                    } else if (self.isDatepicker($(this))) {
                        $(this)[0].value = fieldVal;
                    } else if (self.isCheckboxRadio($(this))) {
                        let selectedArr = fieldVal.split(",")
                        let valueOfControl = $(this).attr('value');
                        (selectedArr.indexOf(valueOfControl) != -1) ? $(this).prop('checked', true) :
                            $(this).prop('checked', false);

                    } else {
                        $(this).val(fieldVal);
                    }
                } else {
                    var valToAdd = "";
                    if (newObj[index].hasOwnProperty(strArray[0])) {
                        valToAdd = self.findProp(newObj[index], dataFieldName);
                        if (valToAdd != null && valToAdd != "") {
                            var submitFormat = self.findProp(newObj[index], dataFieldName + "_submitDateFormat", "");
                            if (submitFormat != null && submitFormat != "") {
                                valToAdd = self.getDisplayDate($(this), submitFormat, valToAdd);
                                self.clearProp(newObj[index], dataFieldName + "_submitDateFormat", "");
                            }
                        }
                    }
                    if (self.isMultiSelect($(this))) {
                        self.setMultiSelectVal($(this), valToAdd);
                    } else if (self.isDatepicker($(this))) {
                        $(this)[0].value = valToAdd;
                    } else if (self.isCheckboxRadio($(this))) {
                        let selectedArr = valToAdd.split(",")
                        let valueOfControl = $(this).attr('value');
                        (selectedArr.indexOf(valueOfControl) != -1) ? $(this).prop('checked', true) :
                            $(this).prop('checked', false);
                    }
                    else {
                        $(this).val(valToAdd);
                    }
                }
            } else {
                if (newObj[index] != null) {
                    if (self.isMultiSelect($(this))) {
                        self.setMultiSelectVal($(this), newObj[index]);
                    } else {
                        $(this).val(newObj[index]);
                    }
                }
            }
        });
    },
    setMultiSelectVal(obj, value) {
        if (value != null && value != "") {
            if (!$.isArray(value)) {
                value = value.split(",");
            }
            obj[0].slim.set(value);
        }
    },
    isMultiSelect(obj) {
        return ($(obj).is("select") && $(obj).attr("multiple") != undefined);
    },
    isDatepicker(obj) {
        var inputType = $(obj).attr("type");
        return (inputType == "hidden" && $(obj).hasClass("datepickerctrl"));
    },
    isCheckboxRadio(obj) {
        var inputType = $(obj).attr("type");
        return (inputType == "radio" || inputType == "checkbox");
    },
    updateDataSourceAttribute(eleObj) {
        let dataSource = $(eleObj).attr('data-datasource');
        let dataSourceArr = dataSource.split(".");
        if (dataSourceArr.length == 1) {
            $(eleObj).attr('data-datasource', this.dummyKey + "." + dataSource);
        }
    },
    splitDataSourceAndPopulateRow(eleObj, dataJson) {
        var self = this;
        this.emptyRepeatableRow = dataJson == null || $.isEmptyObject(dataJson);
        let dataSource = $(eleObj).attr('data-datasource');
        let dataSourceArr = dataSource.split(".");
        if (dataSourceArr.length == 1) {
            if (!$.isEmptyObject(dataJson) && dataJson.hasOwnProperty(dataSourceArr[0])) {
                let oldJsonObj = JSON.parse(JSON.stringify(dataJson[dataSourceArr[0]]));
                this.oldJSON[dataSourceArr[0]] = oldJsonObj;
                let tempObj = JSON.parse(JSON.stringify(this.oldJSON))[dataSourceArr[0]];
                this.oldRepeatableRowData = {};
                for (let i = 1; i < dataSourceArr.length; i++) {
                    tempObj = this.remove(tempObj, dataSourceArr[i]);
                    tempObj = tempObj[dataSourceArr[i]];
                }
                this.createObject(this.oldRepeatableRowData, dataSource, tempObj);
            }
            dataSourceArr.splice(0, 0, this.dummyKey);
            $(eleObj).attr('data-datasource', this.dummyKey + "." + dataSource);
            dataSource = this.dummyKey + "." + dataSource;
        }

        if (dataJson == null) {
            dataJson = {};
        }
        var jsonData = {};

        if (!dataJson.hasOwnProperty(dataSourceArr[0])) {
            jsonData[dataSourceArr[0]] = dataJson;
            dataJson = jsonData;
        } else {
            let oldJsonObj = JSON.parse(JSON.stringify(dataJson[dataSourceArr[0]]));
            this.oldJSON[dataSourceArr[0]] = oldJsonObj;
            let tempObj = JSON.parse(JSON.stringify(this.oldJSON[dataSourceArr[0]]));
            this.oldRepeatableRowData = {};
            for (let i = 1; i < dataSourceArr.length; i++) {
                tempObj = this.remove(tempObj, dataSourceArr[i]);
                tempObj = tempObj[dataSourceArr[i]];
            }
            this.createObject(this.oldRepeatableRowData, dataSource, tempObj);
        }

        this.initialUpdatingOfDataJson(dataSource, dataSourceArr[dataSourceArr.length - 1], dataJson, eleObj);
        if (this.emptyRepeatableRow) {
            this.addNewEntryToJson(window.dataAsJson[dataSource], dataSource);
        }
        this.populateRepeatableRow(dataSource, dataSourceArr[dataSourceArr.length - 1], dataJson, eleObj);
        this.bindAddDeleteEventsForRepeatableRow();
        let attrVal = $(eleObj).attr("isreadonly")
        if (!this.oldRepRow.hasOwnProperty(dataSource) && attrVal == 'false' &&
            !$.isEmptyObject(this.oldRepeatableRowData)) {
            this.oldRepRow[dataSource] = this.oldRepeatableRowData;
            this.oldRepeatableRowData = {};
        }
        this.updateReadOnlyState();
    },
    updateReadOnlyState() {
        var self = this;
        $("#rendererForm").find(`[data-repeatablerow="true"]`).not('[child-repeatablerow]')
            .each(function (index1, element) {
                self.updateChildrenToReadonly($(this));
                $(this).find(`[data-repeatablerow="true"]`).each(function (index2, element2) {
                    self.updateChildrenToReadonly($(this));
                });
            });
    },
    generateChildRows(dataAsJson, parentRow, rowIndex) {
        var self = this;
        let parentRowDataSrc = $(parentRow).attr("data-datasource");
        let parentRepRow = $(`[data-repeatablerow="true"][data-datasource="${parentRowDataSrc}"]`).eq(rowIndex);
        $(parentRepRow).find(`[data-repeatablerow="true"]`).not(':first').remove();
        // Check for child repeatable row
        $(parentRepRow).find(`[data-repeatablerow="true"]`).each(function (index1, element) {
            let obj = self.findProp(dataAsJson, $(this).attr('data-datasource'));
            if (obj != null) {
                for (let i = 0; i < obj.length - 1; i++) {
                    let repData = $(this).data('obj');
                    let ele = window.generateRow(repData, null, $(this));
                }
            }
        });
    },
    populateRepeatableRow(originalDataSource, dataSource, dataAsJson, eleObj) {
        let obj;
        let newObj = [];
        var isArrayInsideArray = true;
        var el = $('<div name="repeatable-row-data" class="d-none"></div>');
        let customDLData = {}
        $(eleObj).find('[dataListName]').each((i, dataListName) => {
            let dlName = $(dataListName).attr("datalistname");
            customDLData[dlName] = $(dataListName).data("selectData")
        })
        var self = this;
        $('body').append(el);
        // Find the data-source
        $("div[remove_this_item]").remove();
        if (originalDataSource != dataSource) {
            obj = self.recursiveKeySearch(dataSource, dataAsJson, el);
        } else {
            obj = self.recursiveKeySearch(dataSource, dataAsJson[originalDataSource], el);
        }

        // Take out array elements\
        for (let i = 0; i < obj.length; i++) {
            if (obj[i].constructor === Array) {
                for (let j = 0; j < obj[i].length; j++) {
                    newObj.push(obj[i][j]);
                }
            }
        }

        if (newObj && newObj.length == 0) {
            newObj = obj;
            isArrayInsideArray = false;
        }

        // Generate rows based on json data.
        for (let i = 0; i < newObj.length - 1; i++) {
            let ds = (originalDataSource.indexOf(this.dummyKey) != -1 ? dataSource : originalDataSource)

            // Find parent
            let ele = window.generateRow(self.repeatableData[ds], null, self.firstRowElement[ds]);
            this.updateDataSourceAttribute(ele)
            this.updateNewName(originalDataSource);
        }

        for (let i = 0; i < newObj.length; i++) {
            let ds = (originalDataSource.indexOf(this.dummyKey) != -1 ? dataSource : originalDataSource)
            this.generateChildRows(newObj[i], self.firstRowElement[ds], i);
            this.updateNewName(originalDataSource);
        }

        setTimeout(function () {
            self.afterRowCreate(customDLData, originalDataSource, newObj, isArrayInsideArray);
        }, 0)


    },
    async afterRowCreate(customDLData, originalDataSource, newObj, isArrayInsideArray) {
        var self = this;
        await new Promise((resolve, reject) => setTimeout(() => {
            if (customDLData != null) {
                $('[data-repeatablerow]').find('[dataListName]').each((i, datalistEle) => {
                    CustomDataList.populateDropdownWithData(datalistEle, customDLData[$(datalistEle).attr('datalistname')]);
                })
            }
            resolve("done!")
        }, 100));
        window.bindMultiSelectDropdownIntegrated(true);
        self.updateRowContainers(originalDataSource, newObj, isArrayInsideArray);
        window.bindDatePickerIntegrated(true);
    },
    updateRowContainers(originalDataSource, newObj, isArrayInsideArray) {
        var self = this;
        var dynamicParams=[];
        $(`[data-repeatablerow="true"][data-datasource="${originalDataSource}"]`).each(function (index) {
            $(this).attr("newname", self.getNameForRepeatableRowElements(originalDataSource, index));
            var parentName = $(this).attr("newname");
            var jsonData = {};
            self.updateChildDataField($(this), parentName, index, jsonData, newObj, isArrayInsideArray, false, '');
            // Find child rep row
            $(this).find(`[data-repeatablerow="true"]`).each(function (index1, element) {
                var repRowName = $(this).attr("newname");
                var childDataSrcName = $(this).attr("data-datasource");
                var childRepData = {};
                var parentNameMerged = parentName + "." + repRowName;
                let childObj = newObj[index][childDataSrcName];
                if (childObj != null) {
                    $(this).attr("childnewname", parentNameMerged);
                    self.updateChildDataField($(this), repRowName, index1, childRepData, childObj, isArrayInsideArray, true, parentNameMerged);
                    if (!jsonData.hasOwnProperty(childDataSrcName)) {
                        jsonData[childDataSrcName] = []
                    }
                    jsonData[childDataSrcName].push(childRepData);
                }
            });

            /*
             * Check if typeahead is dependent on another field of
             * the repeatable row.
             */
            //TypeaheadUtils.updateTypeAheadJsonForRepeatable($(this));
            dynamicParams.push($(this));
        });
        if(dynamicParams.length>0){
            $("#typeahead-repeatable-wait").removeClass("d-none");
            TypeaheadUtils.updateDynamicTypeAheadData("",dynamicParams).then(() => {
                $("#typeahead-repeatable-wait").addClass("d-none");
            });
        }
    },
    getValueOfControl(ele) {
        if (this.isCheckboxRadio(ele)) {
            let selectedVal = '';
            let elementName = $(ele).attr('name');
            // get name
            $(`[name='${elementName}']`).each(function () {
                if ($(this)[0].checked) {
                    if (selectedVal != "") {
                        selectedVal = selectedVal + "," + $(this).attr('value');
                    } else {
                        selectedVal = $(this).attr('value');
                    }
                }
            })
            return selectedVal;
        } else {
            return $(ele).val();
        }
    },
    getValue(ele) {
        if (this.isCheckboxRadio(ele)) {
            let selectedVal = '';
            if ($(ele)[0].checked) {
                selectedVal = $(ele).attr('value');
            }
            return selectedVal;
        } else {
            return $(ele).val();
        }
    },
    loadDatafieldsIntoObject(jsonObj, rowEle, parentName) {
        var self = this;

        $(rowEle).find("[data-datafield]").each(function () {
            let repRowName = self.getParentRepRowName($(this));
            if (parentName != repRowName) {
                return;
            }
            var dataFieldName = $(this).attr("data-datafield");
            var defaultValueOfControl = self.getValueOfControl($(this));
            var strArray = dataFieldName.split('.');
            if (strArray.length == 1) {
                jsonObj[dataFieldName] = defaultValueOfControl;
            } else {
                var current = jsonObj;
                for (var j = 0; j < strArray.length; j++) {
                    if (j == strArray.length - 1) {
                        if (defaultValueOfControl != null) {
                            current[strArray[j]] = defaultValueOfControl;
                        } else {
                            current[strArray[j]] = "";
                        }
                    } else if (!current.hasOwnProperty(strArray[j])) {
                        current[strArray[j]] = {};
                    }
                    current = current[strArray[j]];
                }
            }

        });
    },
    addNewEntryToJson(jsonData, dataSrcOriginal) {
        var arrayOfDataField = [];
        var ent = {};
        var expenseEntity = {};
        var dataSrc = dataSrcOriginal.split(".");
        var self = this;
        $(`[data-repeatablerow="true"][data-datasource="${dataSrcOriginal}"]`).each(function (index, rowEle) {
            var parentName = $(this).attr("newname");
            self.loadDatafieldsIntoObject(ent, $(rowEle), parentName);
            // Find child repeatable row
            $(this).find(`[data-repeatablerow="true"]`).each(function (index1, element) {
                $(element).attr("child-repeatablerow", "true");
                let childDataSrc = $(element).attr("data-datasource");
                ent[childDataSrc] = [];
                let childName = self.getNameForRepeatableRowElements(childDataSrc, index1);
                $(this).attr("newname", childName);
                let obj = {}
                self.loadDatafieldsIntoObject(obj, $(element), childName);
                ent[childDataSrc].push(obj);
            });
        });
        arrayOfDataField.push(ent);
        var dataSrcName = dataSrc[dataSrc.length - 1];
        expenseEntity[dataSrcName] = arrayOfDataField;

        if (dataSrcOriginal != dataSrcName) {
            jsonData[dataSrc[0]] = expenseEntity;
        } else {
            jsonData[dataSrc[0]] = expenseEntity[dataSrc[0]];
        }
    },

    getNameForRepeatableRowElements(originalDataSource, index) {
        let dataSourceArr = originalDataSource.split(".");
        let dataSource = dataSourceArr[dataSourceArr.length - 1];
        if (dataSourceArr.length == 1) {
            return originalDataSource + "[" + index + "]";
        }

        var retnString = "";
        if ($("[name='" + dataSourceArr[0] + "']").find("[name='" + dataSource + "']").length > 0
            && $("[name='" + dataSourceArr[0] + "']").find("[name='" + dataSource + "']").length >= index) {
            var eleObj = $("[name='" + dataSourceArr[0] + "']").find("[name=" + dataSource + "]")[index];
            var indexAttr = $(eleObj).attr("personal-index");
            if (typeof indexAttr !== typeof undefined) {
                retnString = dataSource + "[" + indexAttr + "]";
            } else {
                retnString = dataSource;
            }

            while ($(eleObj).length > 0 && $(eleObj).parent().attr('name') != 'repeatable-row-data') {
                eleObj = $(eleObj).parent();
                let attr = eleObj.attr('istypearray');
                if (typeof attr !== typeof undefined && attr !== false) {
                    var curName = $(eleObj).attr('name');
                    var items = $('[name="' + curName + '"]');
                    if (eleObj.parent()) {
                        items = eleObj.parent().children('[name="' + curName + '"]');
                    }
                    retnString = eleObj.attr("name") + '[' + items.index($(eleObj)) + ']' + '.' + retnString;
                } else {
                    retnString = eleObj.attr("name") + '.' + retnString;
                }
            }
        }
        if (retnString.indexOf(this.dummyKey) != -1) {
            return retnString.replace(this.dummyKey + ".", "");
        } else {
            return retnString;
        }
    },
    findProp(obj, prop, defval) {
        if (typeof defval == 'undefined')
            defval = null;
        prop = prop.split('.');
        for (var i = 0; i < prop.length; i++) {
            if (typeof obj[prop[i]] == 'undefined')
                return defval;
            obj = obj[prop[i]];
        }
        return obj;
    },
    clearProp(obj, prop, defval) {
        if (typeof defval == 'undefined')
            defval = null;
        prop = prop.split('.');
        for (var i = 0; i < prop.length; i++) {
            if (typeof obj[prop[i]] == 'undefined')
                return defval;
            if (i == prop.length - 1) {
                obj[prop[i]] = "";
            }
            obj = obj[prop[i]];

        }
        return obj;
    },
    recursiveKeySearch(key, data, parentEleObj) {
        // Handle null edge case.
        if (data === null) {
            // nothing to do here
            return [];
        }
        // handle case of non-object, which will not be searched
        if (data !== Object(data)) {
            return [];
        }
        var results = [];
        // Handle array which we just traverse and recurse.
        if (data.constructor === Array) {
            for (var i = 0, len = data.length; i < len; i++) {
                if (data[i] == null) {
                    data.splice(i, 1);
                    if (i != 0) {
                        i--;
                    } else {
                        i = -1;
                    }
                    len = data.length;
                    if (len == 0) {
                        // Remove parentEleObj
                        parentEleObj.attr("remove_this_item", "");
                    }
                } else {
                    if (i != 0) {
                        var name = parentEleObj.attr("name");
                        var el = $('<div name="' + name + '" id="'
                            + this.getNewGUIDString() + '">' + name
                            + '</div>');
                        parentEleObj.after(el);
                        parentEleObj = el;
                    }
                    parentEleObj.attr("istypearray", true);
                    parentEleObj.attr("personal-index", i);

                    results = results.concat(this.recursiveKeySearch(key,
                        data[i], parentEleObj));
                }
            }
            return results;
        }
        // We know we have an general object to work with now.
        // Now we need to iterate keys
        for (var dataKey in data) {
            var el = $('<div name="' + dataKey + '" id="'
                + this.getNewGUIDString() + '">' + dataKey + '</div>');
            parentEleObj.append(el);
            if (key === dataKey) {
                el.attr("current-index", parentEleObj.children(
                    `[name="${dataKey}"]`).index(el));
                results.push(data[key]);
            }

            // now recurse into value at key
            results = results.concat(this.recursiveKeySearch(key, data[dataKey], el));
        }
        return results;
    },
    getNewGUIDString() {
        // your favourite guid generation function could go here
        // ex: http://stackoverflow.com/a/8809472/188246
        let d = new Date().getTime();
        if (window.performance && typeof window.performance.now === "function") {
            d += performance.now(); // use high-precision timer if available
        }
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            let r = (d + Math.random() * 16) % 16 | 0;
            d = Math.floor(d / 16);
            return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);
        });
    },
    generateId() {
        let text = "";
        var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
        for (var i = 0; i < 7; i++)
            text += possible.charAt(Math.floor(Math.random() * possible.length));

        return text;
    },
    getDisplayDate(eleObj, submittedFormat, dateValue) {
        try {
            if (dateValue != "") {
                var displaydateformat = eleObj.attr("displaydateformat");
                if (displaydateformat == null || displaydateformat == "") {
                    displaydateformat = "DD-MMM-YYYY";
                }
                var actualDate = moment(dateValue, submittedFormat).toDate().getTime();
                return moment(actualDate).format(displaydateformat);
            }
        } catch (e) {
            return dateValue;
        }
    }
}
export default Repeatable_Utils;